var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("药销通核心应用")]),_c('div',{staticClass:"steps flex-row flex-center"},[_c('img',{attrs:{"src":_vm.ImgUrl,"alt":""}})]),_c('div',{staticClass:"bottom"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }